import { SeasonPlan } from '@coin/shared/core/util-models';
import { SeasonRecord } from './incentive-record.model';
import { ReassignmentActionEnum } from '../enums/reassignment-action.enum';

export class Reassignment {
  id: string;
  newPlanId: string;
  planId: string;
  newRecordId: string;
  recordId: string;
  newRecordStartsAt: string;
  recordEndsAt: string;
  createdAt: string;

  causedBy: ReassignmentCause;
  state: ReassignmentStatus;
  action: ReassignmentActionEnum;

  plan: SeasonPlan;
  newPlan: SeasonPlan;
  record: SeasonRecord;
  newRecord: SeasonRecord;

  constructor(dto: unknown) {
    Object.assign(this, dto);
  }
}

export class CreateReassignment {
  employeeId: string;
  newPlanId: string;
  seasonId: string;
  comment: string;

  plan: SeasonPlan; // local

  newRecordStartsAt?: string;
  recordEndsAt?: string;
}

export enum ReassignmentStatus {
  Unknown = 'Unknown',
  Created = 'Created',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Deactivated = 'Deactivated',
  Manual = 'Manual'
}

export enum ReassignmentCause {
  PlanChanger = 'PlanChanger',
  NewEligible = 'NewEligible',
  NoLongerEligible = 'NoLongerEligible',
  Termination = 'Termination',
  CompanyEntryDate = 'CompanyEntryDate',
  ContractStatus = 'ContractStatus',
  ManagementGroup = 'ManagementGroup',
  TargetIncentiveAmount = 'TargetIncentiveAmount',
  Manual = 'Manual'
}
